import { useLocation, useNavigate } from 'react-router-dom';

function stripLightingBase(pathname: string) {
  const stripped = pathname.replace(/^\/lighting(?=\/|$)/, '');
  return stripped || '/';
}

function lightingPath(href: string) {
  if (!href.startsWith('/')) return href;
  if (href === '/') return '/lighting';
  if (href.startsWith('/lighting')) return href;
  return `/lighting${href}`;
}

export function usePathname() {
  return stripLightingBase(useLocation().pathname);
}

export function useRouter() {
  const navigate = useNavigate();
  return {
    push: (href: string) => navigate(lightingPath(href)),
    replace: (href: string) => navigate(lightingPath(href), { replace: true }),
    back: () => navigate(-1),
  };
}
